<template>
  <div class="content_wrap">
    <div class="	">
      <div class="login_main clearfix">
        <div class="login_main_top">
          <span class="second_font">用户登录</span>
        </div>
        <!--<div class="step_status step2"></div>-->
        <div class="login_item_box">
          <div class="input_item  clearfix">
            <label class="input_item_left content_font"><i>*</i>联系电话：</label>
            <div class="input_item_right">
              <input class="input_common" v-model="phone" type="text" placeholder="请输入您的手机号" maxlength="11" />
            </div>
          </div>
          <div class="input_item clearfix">
            <label class="input_item_left content_font"><i>*</i>验证码：</label>
            <div class="input_item_right">
              <div id="slider"></div>
            </div>
          </div>
          <div class="input_item clearfix">
            <label class="input_item_left content_font"><i>*</i>短信验证码：</label>
            <div class="input_item_right">
              <input class="input_common" v-model="smsCode" type="text" placeholder="请输入您的短信验证码">
              <a href="javascript:;" class="yam_btn" @click="smsVerification" v-text="seconds">获取短信验证码</a>
            </div>
          </div>
        </div>
        <div class="checkBox">
          <p>
            <img :src="imgCheckFlag ? checkImg : noCheckImg" alt="" @click="imgCheckFlag = !imgCheckFlag"
              class="checkImg">
            同意<a href="/#/privacyServiceAgreement" target="_blank">《银税通平台隐私政策》</a>
          </p>
        </div>
        <div class="login_btn_box registerStyle">
          <!--						<a href="#/register/firstStep" class="bluebd_btn mr10">&nbsp;取&nbsp;&nbsp;消&nbsp;</a>
-->
          <a class="login_btn second_font " @click="sumbit">登录</a>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import SliderVerification from '../assets/js/slider'
import noCheckImg from '@/assets/images/check.png'
import checkImg from '@/assets/images/checked.png'

let timer = null
export default {
  name: 'firstStep',
  data() {
    return {
      OrganizationName: '', //机构名称
      email: '', //企业邮箱
      phone: '', //联系电话
      smsCode: '',
      isShow: true, //短信验证码60秒显示
      seconds: "获取短信验证码",
      isGetCode: false, //是否已经滑块验证通过
      noCheckImg: noCheckImg,
      checkImg: checkImg,
      imgCheckFlag: false // 是否通过了隐私协议
    }
  },
  mounted() {
    //生成滑块
    new SliderVerification('#slider', {
      width: '330',
      height: '40',
      verifInfo: '/ystOpenPlatformBff/api/verifInfo',
      checkVerif: '/ystOpenPlatformBff/api/checkVerif',
    });
  },
  methods: {
    sumbit() {
      let params = {
        "phone": this.phone,
      }
      if (this.check.calibration(params)) {
        if (sessionStorage.getItem('token') || this.isGetCode) {
          params.smsCode = this.smsCode;
          if (this.check.calibration(params)) {
            if (!this.imgCheckFlag) {
              return this.$Message.error({
                content: "请先勾选同意相关协议",
                duration: 2
              })
            }
            this.http.post('/ystOpenPlatformBff/loginByPhone', params, res => {
              if (res.success) {
                this.$router.push(`/${this.$route.query.redirect || 'apiCenter'}`)
              } else {
                this.$Message.error({
                  content: res.message,
                  duration: 2
                })
              }
            })
          }
        } else {
          this.$Message.error({
            content: '滑块验证码证书失效或者未验证,请验证滑块验证码！',
            duration: 2
          })
        }
      }
    },
    //短信验证
    smsVerification() {
      let pattern = /^1\d{10}$/
      if (!pattern.test(this.phone)) {
        return this.$Message.error({
          content: '请输入正确的手机号！',
          duration: 2
        })
      }
      const that = this;
      if (this.isShow) {
        let params = {
          telephoneNum: this.phone,
          cert: sessionStorage.getItem('token')
        }
        if (this.check.calibration(params)) {
          this.http.post('/ystOpenPlatformBff/sendSmsCode', params, res => {
            if (res.success) {
              this.$Message.info({
                content: '获取手机验证码成功，请输入手机上的验证码完成验证！',
                duration: 2
              })
              sessionStorage.setItem('token', '')
              this.isShow = false;
              let time = 60;
              this.isGetCode = true
              timer = setInterval(function () {
                if (time > 0) {
                  that.seconds = time + "秒后重新验证"
                  time--;
                } else {
                  clearInterval(timer)
                  that.isShow = true;
                  that.seconds = "获取短信验证码";
                  this.isGetCode = false;
                  $('#slider').html('')
                  new SliderVerification('#slider', {
                    width: '330',
                    height: '40',
                    verifInfo: '/ystOpenPlatformBff/api/verifInfo',
                    checkVerif: '/ystOpenPlatformBff/api/checkVerif',
                  });
                }
              }, 1000)
              this.$once('hook:beforeDestroy', () => {
                clearInterval(timer)
                timer = null
              })
            } else {
              this.isGetCode = false
              this.$Message.error({
                content: '滑块验证码证书失效或者未验证,请验证滑块验证码！',
                duration: 2
              })
            }
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
.step2 {
  background: url(../assets/images/regist_step2.jpg) no-repeat;
  background-size: 100%;
}

.checkImg {
  margin-bottom: -4px;
  padding-right: 4px;
}

.checkBox {
  padding-left: 80px;
  padding-bottom: 10px;
}

.login_main {
  width: 600px;
  margin: 0 auto;
  background: $white;
  padding: 20px 20px 0 20px;
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
}

.login_main_top {
  position: relative;
  padding-bottom: 20px;
  border-bottom: 1px solid $border;
  height: 40px;
  line-height: 20px;

  .login_user {
    position: absolute;
    right: 0;
  }
}

.login_item_box {
  padding-top: 27px;
  padding-bottom: 10px;

  .input_item {
    height: 40px;
    margin-bottom: 20px;
  }

  .input_item_left {
    width: 28%;
    margin-right: 2%;
    float: left;
    text-align: right;
    line-height: 40px;

    i {
      font-style: normal;
      color: $circle;
      font-size: 16px;
    }
  }

  .input_item_right {
    width: 66%;
    float: left;
    position: relative;

    .yam_btn {
      color: #0080cc;
      position: absolute;
      line-height: 40px;
      right: 52px;
      top: 0;
      font-size: 14px;
    }
  }
}

.login_btn_box {
  width: 560px;
  margin: 0 auto;
  text-align: center;
  padding: 30px 0;
  border-top: 1px solid $border;
}

.registerStyle {
  padding: 13px 0;
}
</style>


// WEBPACK FOOTER //
// src/page/LoginByPhone.vue